import React from "react";
import PropTypes from "prop-types";

import Isvg from "../../../vendor/react-inlinesvg";
import TreeItem from "./tree-item";

class Tree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data
    };

    this._slideListItems = this._slideListItems.bind(this);
    this._clickListItem = this._clickListItem.bind(this);
    this._onCheck = this._onCheck.bind(this);
    this._arrowSlideItem = this._arrowSlideItem.bind(this);
    this._findingNemo = this._findingNemo.bind(this);
    this._bulidLocArray = this._bulidLocArray.bind(this);
    this._areChildrenEmpty = this._areChildrenEmpty.bind(this);
    this._buildTree = this._buildTree.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._windowResize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      if (this.state.data) {
        this.setState({
          data: $.extend(nextProps.data, this.state.data, true)
        });
      } else {
        this.setState({ data: nextProps.data });
      }
    }
  }

  _slideListItems(e) {
    const dataLoc = $(e.currentTarget)
      .parent()
      .data("locator");
    const currCollection = this._findingNemo(
      this.props.data,
      this._bulidLocArray(dataLoc)
    );
    currCollection.expanded = !currCollection.expanded;
    const parent = $(e.currentTarget)
      .parent()
      .nextAll("ul")
      .slice(0, 10);
    parent.slideToggle(100, () => this.forceUpdate());
  }

  _clickListItem(e, tree) {
    this._arrowSlideItem(e, tree);
    if (tree.callback) {
      tree.callback(e);
    }
  }

  _onCheck(e, tree) {
    tree.onCheck(e, tree);
  }

  _arrowSlideItem(e, tree) {
    if (tree.children.length) {
      this._slideListItems(e);
    }
  }

  _findingNemo(currentTSC, locArray) {
    const index = locArray.shift();
    const newTSC = currentTSC[index];
    if (locArray.length === 0) {
      return newTSC;
    } else {
      return this._findingNemo(newTSC.children, locArray);
    }
  }

  _bulidLocArray(locString) {
    locString = locString + "";
    const locArray = locString.split(".");
    return locArray.map(elem => parseInt(elem, 10));
  }

  _areChildrenEmpty(section) {
    return !section.children.some(child => child.count && child.count > 0);
  }

  _buildTree(data, level, index, parentExpanded) {
    return data.map((node, i) => {
      if (node.hideIfEmpty) {
        if (node.count === 0) {
          return null;
        } else {
          if (this._areChildrenEmpty(node)) {
            node.children = [];
          }
        }
      }
      const childClass = `child-${level} ${
        parentExpanded ? "show-subnav" : ""
      }`;
      return (
        <ul
          key={"tree-list-" + i}
          className={`slider-list-container ${childClass}`}
        >
          <TreeItem
            i={i}
            index={index}
            level={level}
            key={"tree-item-" + i}
            collectionstree={node}
            selectedLoc={this.props.selectedLoc}
            checkbox={this.props.checkbox}
            buildTree={this._buildTree}
            clickListItem={this._clickListItem}
            onCheck={this._onCheck}
            arrowSlideItem={this._arrowSlideItem}
          />
        </ul>
      );
    });
  }

  render() {
    return <div>{this._buildTree(this.props.data, 1, "", true)}</div>;
  }
}

Tree.propTypes = {
  checkbox: PropTypes.bool,
  selectedLoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      books: PropTypes.array,
      callback: PropTypes.func,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          books: PropTypes.array,
          callback: PropTypes.func,
          children: PropTypes.array,
          count: PropTypes.number,
          title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        })
      ),
      count: PropTypes.number,
      title: PropTypes.string
    })
  )
};

Tree.defaultProps = {
  checkbox: false,
  selectedLoc: "",
  data: []
};

module.exports = Tree;
